import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  UPDATE,
  UPDATE_SUCCESS,
  UPDATE_FAILED,
  SET_FETCH_PARAMS,
} from './constants';

export interface InitAction {
  type: typeof INIT;
}

export interface InitSuccessAction {
  type: typeof INIT_SUCCESS;
}

export interface InitFailedAction {
  type: typeof INIT_FAILED;
  error: Error;
}

export interface UpdateAction {
  type: typeof UPDATE;
  userId: string;
  unblock: boolean;
}

export interface UpdateSuccessAction {
  type: typeof UPDATE_SUCCESS;
  userId: string;
}

export interface UpdateFailedAction {
  type: typeof UPDATE_FAILED;
  userId: string;
  error: Error;
}

export interface SetFetchParamsAction {
  type: typeof SET_FETCH_PARAMS;
  params: Partial<{
    pageNum: number;
    limit: number;
    search: string;
  }>;
}

export type OrganizersListPageAction =
  | InitAction
  | InitSuccessAction
  | InitFailedAction
  | UpdateAction
  | UpdateSuccessAction
  | UpdateFailedAction
  | SetFetchParamsAction;

export const initAction = (): InitAction => ({
  type: INIT,
});

export const initSuccessAction = (): InitSuccessAction => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error: Error): InitFailedAction => ({
  type: INIT_FAILED,
  error,
});

export const updateAction = (userId: string, unblock: boolean): UpdateAction => ({
  type: UPDATE,
  userId,
  unblock,
});

export const updateSuccessAction = (userId: string): UpdateSuccessAction => ({
  type: UPDATE_SUCCESS,
  userId,
});

export const updateFailedAction = (userId: string, error: Error): UpdateFailedAction => ({
  type: UPDATE_FAILED,
  userId,
  error,
});

export const setFetchParamsAction = (
  params: Partial<{
    pageNum: number;
    limit: number;
    search: string;
  }>
): SetFetchParamsAction => ({
  type: SET_FETCH_PARAMS,
  params,
});
